import { publicApi, tenantApi } from '@/helpers/apiClient'
import {
  invitationPreviewDtoSchema,
  tenantLoginResponseDtoSchema,
  tenantSessionDtoSchema,
  type InvitationPreviewDto,
  type TenantLoginResponseDto,
  type TenantSessionDto,
} from '@lib/dto/tenant-auth.dto'
import type {
  AcceptInvitationInput,
  PasswordResetConfirmInput,
  PasswordResetRequestInput,
  TenantLoginInput,
} from '@lib/input/tenant-auth.input'
import type { ITenantAuthService } from '@/types/TenantAuthService.types'

/** Tenant dashboard sign-in, session, password reset, and invitations. */
class TenantAuthService implements ITenantAuthService {
  login(input: TenantLoginInput): Promise<TenantLoginResponseDto> {
    return publicApi.post('/tenant-auth/login', input, tenantLoginResponseDtoSchema)
  }

  me(): Promise<TenantSessionDto> {
    return tenantApi.get('/tenant-auth/me', tenantSessionDtoSchema)
  }

  async logout(): Promise<void> {
    await tenantApi.postEmpty('/tenant-auth/logout')
  }

  async requestPasswordReset(input: PasswordResetRequestInput): Promise<void> {
    await publicApi.postEmpty('/tenant-auth/password-reset/request', input)
  }

  async confirmPasswordReset(input: PasswordResetConfirmInput): Promise<void> {
    await publicApi.postEmpty('/tenant-auth/password-reset/confirm', input)
  }

  previewInvitation(token: string): Promise<InvitationPreviewDto> {
    return publicApi.get(
      `/tenant-auth/invitations/${encodeURIComponent(token)}`,
      invitationPreviewDtoSchema,
    )
  }

  acceptInvitation(token: string, input: AcceptInvitationInput): Promise<TenantLoginResponseDto> {
    return publicApi.post(
      `/tenant-auth/invitations/${encodeURIComponent(token)}/accept`,
      input,
      tenantLoginResponseDtoSchema,
    )
  }
}

export const tenantAuthService = new TenantAuthService()
